import React from 'react'
import { FiChevronRight, FiChevronDown, FiPlusCircle } from 'react-icons/fi'
import { experiments, jobList } from './mock'
import {getTime} from '../../../@shared/utils'

export const FeatureEdit = ({id, preview}) => {
    const [show] = React.useState(true)
    let item = {
        title:'Experiment',
        description:'Enter your experiment information'
}
    const [limit,setLimit] = React.useState(2)
    return (
        <div className="features">
            <div className="heading">
                <div>
                    <h4>{item?.title}</h4>
                    <p>{item?.description}</p>
                </div>
                <div className="flex-end">
                    {false && !preview && (
                        <FiPlusCircle style={{marginRight:'1em'}} size={20} onClick={()=>{
                              
                        }}/>
                    )}

                    <div className="setting" >
                        {!show ? <FiChevronRight />: <FiChevronDown /> }
                    </div>
                </div>
                
            </div>

            {
            show && experiments.length > 0 && (<React.Fragment>
                <ul>
                {   
                     experiments.map((item,i)=>
                     true ? 
                     (
                        <li key={'experiences'+i*i} >
                            <h4 className="title">{item?.position}</h4>
                            <h5 className="name">{item?.company}</h5>
                            {item.start && <p className="date">{getTime(item?.start)} {` / `} {item?.end ? getTime(item?.end) : 'Current'}</p>}
                            <p className="description">{item?.description.substr(1,1000)}</p>
                        </li>
                    ):<></>)
                }
                </ul>
                
                { experiments.length>limit  && <div className="button" onClick={()=>{setLimit(jobList?.length)}}><p>Load more</p></div>  }  

            </React.Fragment>)
            }
        </div>
    );
}

